import { all } from "redux-saga/effects";
import {
  watchFetchLocalAuthentication,
  watchHandleFetchLocalAuthenticationSuccess,
  watchHandleLoginSuccess,
  watchLogin,
  watchLogout,
  watchMount,
  watchUnmount,
} from "./watchers";

export function* authenticationSagas() {
  yield all([
    watchFetchLocalAuthentication(),
    watchHandleFetchLocalAuthenticationSuccess(),
    watchHandleLoginSuccess(),
    watchLogin(),
    watchLogout(),
    watchMount(),
    watchUnmount(),
  ]);
}
